import { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
// import FontSize from "@ckeditor/ckeditor5-font/src/fontsize.js";
// import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment.js";
// import Autosave from "@ckeditor/ckeditor5-autosave/src/autosave.js";
// import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold.js";
// import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily.js";
// import Heading from "@ckeditor/ckeditor5-heading/src/heading.js";
// import Indent from "@ckeditor/ckeditor5-indent/src/indent.js";
// import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic.js";
// import List from "@ckeditor/ckeditor5-list/src/list.js";
// import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph.js";
// import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline.js";
// import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice.js";
// import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials.js";

// import CustomEditor from "./custom-editor/custom-editor";

import "./notes-tab.style.scss";

const NotesTab = () => {
	const [text, setText] = useState("");

	const config = {
		plugins: ClassicEditor.builtinPlugins,
		// toolbar: ClassicEditor.defaultConfig.toolbar.items,
		toolbar: [
			"heading",
			"|",
			"bold",
			"italic",
			"|",
			"outdent",
			"indent",
			"|",
			"bulletedList",
			"numberedList",
			"|",
			"undo",
			"redo",
		],
	};

	// const config = {
	// 	plugins: [
	// 		// FontSize,
	// 		// Alignment,
	// 		// Autosave,
	// 		// Bold,
	// 		// // Essentials,
	// 		// FontFamily,
	// 		// Heading,
	// 		// Indent,
	// 		// Italic,
	// 		// List,
	// 		// Paragraph,
	// 		// // PasteFromOffice,
	// 		// Underline,
	// 	],
	// 	toolbar: [
	// 		// "fontSize",
	// 		// "|",
	// 		// "bold",
	// 		// "underline",
	// 		// "italic",
	// 		// "|",
	// 		// "alignment",
	// 		// "outdent",
	// 		// "indent",
	// 		// "|",
	// 		// "bulletedList",
	// 		// "numberedList",
	// 		// "|",
	// 		// "undo",
	// 		// "redo",
	// 		// "|",
	// 		// "fontFamily",
	// 	],
	// };

	return (
		<div className="notes-container">
			<CKEditor
				editor={ClassicEditor}
				data={text}
				config={config}
				onChange={(event, editor) => {
					const data = editor.getData();
					setText(data);
				}}
			/>
		</div>
	);
};

export default NotesTab;
